module.exports = function (error) {
  console.error(error)
  let { status, data } = error.response
  if (status === 403 || status === 400) {
    if (data.hasOwnProperty('message')) {
      let message = data.message.replace(/[\s]+/g, '')
      if (messageHandle.hasOwnProperty(message)) {
        messageHandle.that = this
        messageHandle[message](data)
      }
      else
        alert('error')
    }
  }
}
var messageHandle = {
  that: '',
  'jwtmalformed': function () {
    alert('登入失效，請重新登入')
    localStorage.removeItem('token')
    this.that.$router.push({name: 'login'})
  },
  'invalidtoken': function () {
    this['jwtmalformed']()
  },
  'jwtexpired': function () {
    this['jwtmalformed']()
  },
  'Accountorpassworderror': function () {
    alert('帳號密碼錯誤')
  },
  'unique': function (data) {
    let unique = {
      tax_id: '統一編號'
    }
    alert(`${unique[data.column]}重複`)
  }
}



// WEBPACK FOOTER //
// ./src/assets/errorHandle.js